export const version = 1;

export function getActiveRoute() {
  return location.hash.slice(1);
}
